<template>
	<div style="height: 100%;">
		<div class="header_box ">
			<div class="p_login p_flex p_f_a ">
				<span class="p_m_l_20 type_size_18">学科</span>
				<div class="p_f_1 p_m_l_20 p_m_r_20">
					<el-select class="p_flex" v-model="subjectTypes" placeholder="请选择" @change="gets">
						<el-option v-for="item in subjectLists" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</div>
			</div>
			<div class="p_login p_flex p_f_a p_m_t_30">
				<span class="p_m_l_20 type_size_18">年级</span>
				<div class="p_f_1 p_m_l_20 p_m_r_20">
					<el-select class="p_flex" v-model="gradeTypes" placeholder="请选择" @change="gets">
						<el-option v-for="item in gradeLists" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</div>
			</div>
		</div>
		<div class="box_center p_m_t_30 overflow" style="height: 70%;">
			<div class="boder_box" v-for="(item, index) in listBook" :key="index">
				<div class="p_flex p_f_a">
					<div class="p_loginb p_f_1 p_flex p_f_a ">
						<div class="p_f_1 p_m_l_20 ">
							<el-select class="p_flex" v-model="item.questionTypes" placeholder="请选择">
								<el-option v-for="val in item.questionType" :key="val.id" :label="val.name" :value="val.id"></el-option>
							</el-select>
						</div>
					</div>
					<!-- <div class="p_f_1">
						<div class="p_flex  p_f_a p_loginb p_m_l_20">
							<div class="p_m_l_20 loginb"><el-input v-model="item.grade"></el-input></div>
							<span class="type_size_18 p_m_r_20">分</span>
						</div>
					</div> -->
					<div class="shan_img small_hand p_m_l_30" @click="newAdd(index)"><img src="../../../../assets/img/daadd.png" /></div>
					<div class="shan_img small_hand p_m_l_30" @click="newDelete(index)"><img src="../../../../assets/img/dashan.png" /></div>
				</div>
				<!-- 单选 -->
				<div class="" v-if="item.questionTypes == 1">
					<div class="" v-for="(val, i) in item.MultipleChoice" :key="i">
						<div class="p_m_t_14 p_flex">
							<div>
								<span class="type_size_22" style="font-weight: bold;">{{ i + 1 }}</span>
							</div>
							<div class="p_flex p_f_1" style="flex-wrap: wrap;">
								<el-radio-group class="p_flex " style="flex-wrap: wrap;" v-model="val.radio" size="small">
									<div id="">
										<el-radio-button v-for="(radio, key) in val.engList" :key="key" :label="radio">
											<span>{{ radio }}</span>
											<div class="xiao_img" v-if="key == val.engList.length - 1" @click.stop="radioDelete(index, i, key)">
												<img src="../../../../assets/img/xiaoshen.png" />
											</div>
										</el-radio-button>
									</div>
									<div class="shan_img small_hand " style="margin-left: 15px;" @click="radiAadd(index, i)"><img src="../../../../assets/img/daadd.png" /></div>
								</el-radio-group>
							</div>
							<div class="" style="width: 120px;">
								<div class="p_flex  p_f_a p_loginb p_m_l_20">
									<div class="p_m_l_20 loginb"><el-input v-model="val.grade"></el-input></div>
									<span class="type_size_18 p_m_r_20">分</span>
								</div>
							</div>
							<div class="shan_img small_hand p_m_l_30" @click="radioDeletes(index, i)"><img src="../../../../assets/img/dashan.png" /></div>
						</div>
						<div class="p_login p_flex p_f_a p_m_t_14">
							<span class="p_m_l_20 type_size_18">解析</span>
							<div class="p_f_1 p_m_l_20 p_m_r_20"><el-input v-model="val.analysis" placeholder="请输入解析"></el-input></div>
						</div>
					</div>
				</div>
				<!-- 多选 -->
				<div class="" v-if="item.questionTypes == 2">
					<div id="" v-for="(val, i) in item.MultiSelect" :key="i">
						<div id="" class="p_m_t_14 p_flex">
							<div>
								<span class="type_size_22" style="font-weight: bold;">{{ i + 1 }}</span>
							</div>
							<div class="p_flex p_f_1 " style="flex-wrap: wrap;">
								<el-checkbox-group class="p_flex " style="flex-wrap: wrap;" v-model="val.choice" size="small">
									<el-checkbox-button v-for="(radio, key) in val.engList" :label="radio" :key="key">
										<span>{{ radio }}</span>
										<div class="xiao_img" v-if="key == val.engList.length - 1" @click.stop="checkboxDelete(index, i, key)">
											<img src="../../../../assets/img/xiaoshen.png" />
										</div>
									</el-checkbox-button>
									<div class="shan_img small_hand p_m_l_30" @click="checkboxAadd(index, i)"><img src="../../../../assets/img/daadd.png" /></div>
								</el-checkbox-group>
							</div>
							<div class="" style="width: 120px;">
								<div class="p_flex  p_f_a p_loginb p_m_l_20">
									<div class="p_m_l_20 loginb"><el-input v-model="val.grade"></el-input></div>
									<span class="type_size_18 p_m_r_20">分</span>
								</div>
							</div>
							<div class="shan_img small_hand p_m_l_30" @click="checkboxDeletes(index, i)"><img src="../../../../assets/img/dashan.png" /></div>
						</div>
						<div class="p_login p_flex p_f_a p_m_t_14">
							<span class="p_m_l_20 type_size_18">解析</span>
							<div class="p_f_1 p_m_l_20 p_m_r_20"><el-input v-model="val.analysis" placeholder="请输入解析"></el-input></div>
						</div>
					</div>
				</div>
				<!-- 判断 -->
				<div class="" v-if="item.questionTypes == 3">
					<div id="" v-for="(val, i) in item.Estimate" :key="i">
						<div class="p_m_t_14 p_flex">
							<div>
								<span class="type_size_22" style="font-weight: bold;">{{ i + 1 }}</span>
							</div>
							<div>
								<el-radio-group class="p_flex " style="flex-wrap: wrap;" v-model="val.judge" size="small">
									<div id="">
										<el-radio-button v-for="(radio, key) in val.judgeList" :key="key" :label="radio.id">
											<span>{{ radio.name }}</span>
										</el-radio-button>
									</div>
								</el-radio-group>
							</div>
							<div class="" style="width: 120px;">
								<div class="p_flex  p_f_a p_loginb p_m_l_20">
									<div class="p_m_l_20 loginb"><el-input v-model="val.grade"></el-input></div>
									<span class="type_size_18 p_m_r_20">分</span>
								</div>
							</div>
							<div class="shan_img small_hand p_m_l_30" @click="estimateDelete(index, i)"><img src="../../../../assets/img/dashan.png" /></div>
						</div>
						<div class="p_login p_flex p_f_a p_m_t_14">
							<span class="p_m_l_20 type_size_18">解析</span>
							<div class="p_f_1 p_m_l_20 p_m_r_20"><el-input v-model="val.analysis" placeholder="请输入解析"></el-input></div>
						</div>
					</div>
				</div>
				<!-- 填空 -->
				<div v-if="item.questionTypes == 4">
					<div v-for="(val, i) in item.GapList" :key="i">
						<div id="" class="p_m_t_14 p_flex">
							<div>
								<span class="type_size_22" style="font-weight: bold;">{{ i + 1 }}</span>
							</div>
							<div class=" p_f_1">
								<div class="p_flex p_f_a">
									<div class="" style="width: 120px;">
										<div class="p_flex  p_f_a p_loginb p_m_l_20">
											<div class="p_m_l_20 loginb"><el-input v-model="val.grade"></el-input></div>
											<span class="type_size_18 p_m_r_20">分</span>
										</div>
									</div>
									<div class="shan_img small_hand p_m_l_30" @click="GapListDelete(index, i)"><img src="../../../../assets/img/dashan.png" /></div>
								</div>
								<div class=" p_f_a">
									<div class="p_m_b_20 p_m_t_20 p_flex p_f_a" v-for="(gap, key) in val.gap" :key="key">
										<div class="p_login p_f_1  p_flex p_f_a">
											<span class="p_m_l_20 type_size_18">{{ key + 1 }}</span>
											<div class="p_f_1 p_m_l_20 "><el-input v-model="gap.text"></el-input></div>
											<div class="xiao_img  small_hand" v-if="key == val.gap.length - 1" @click.stop="gapDelete(index, i, key)">
												<img src="../../../../assets/img/xiaoshen.png" />
											</div>
										</div>
										<div class="shan_img small_hand p_m_l_30" v-if="key == val.gap.length - 1" @click="gapAadd(index, i)">
											<img src="../../../../assets/img/daadd.png" />
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="p_login p_flex p_f_a p_m_t_14">
							<span class="p_m_l_20 type_size_18">解析</span>
							<div class="p_f_1 p_m_l_20 p_m_r_20"><el-input v-model="val.analysis" placeholder="请输入解析"></el-input></div>
						</div>
					</div>
					<div v-if="item.GapList.length != 0">
						<div id="" class="answers_header p_m_t_20 p_flex p_f_1 p_f_b">
							<span>上传图片</span>
							<div class="answers_img">
								<el-upload
									class="upload-demo"
									:action="$request.ajaxUrl + '/Upload/image/type/teacher'"
									:data="{ index }"
									:headers="$request.headers(true)"
									:show-file-list="false"
									multiple
									:on-success="uploadImage"
								>
									<i class="el-icon-picture subject_color type_size_20"></i>
								</el-upload>
							</div>
						</div>
						<div id="">
							<div class="p_flex " style="flex-wrap: wrap;">
								<div style="position: relative;" v-for="img in item.image" :key="img.index">
									<el-image
										style="width: 120px; height: 120px;margin-top: 15px;margin-right: 15px;position: relative;"
										:src="img"
										:preview-src-list="item.image"
									></el-image>
									<div class="xiao_imgs  small_hand" @click.stop="imgDelete(index, img.index)"><img src="../../../../assets/img/xiaoshen.png" /></div>
								</div>
							</div>
						</div>
						<div class="p_m_t_30">
							<div id="">
								<span class="type_size_18">学生答题</span>
								<div id="">
									<el-radio-group v-model="item.patternId">
										<el-radio style="margin-top: 15px;" v-for="(radio, i) in item.pattern" :key="i" :label="radio.id">{{ radio.name }}</el-radio>
									</el-radio-group>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 问答 -->
				<div class="p_m_t_14 " v-if="item.questionTypes == 5">
					<div v-for="(val, i) in item.Questions" :key="i">
						<div id="" class="p_m_t_14 p_flex">
							<div>
								<span class="type_size_22" style="font-weight: bold;">{{ i + 1 }}</span>
							</div>
							<div>
								<div class="p_flex p_f_a">
									<div class="" style="width: 120px;">
										<div class="p_flex  p_f_a p_loginb p_m_l_20">
											<div class="p_m_l_20 loginb"><el-input v-model="val.grade"></el-input></div>
											<span class="type_size_18 p_m_r_20">分</span>
										</div>
									</div>
									<div class="shan_img small_hand p_m_l_30" @click="QuestionsDelete(index, i)"><img src="../../../../assets/img/dashan.png" /></div>
								</div>
							</div>
						</div>
						<div id="" class="answer_conetr p_m_t_14"><el-input type="textarea" :autosize="{ minRows: 4 }" v-model="val.textarea"></el-input></div>
						<div class="p_login p_flex p_f_a p_m_t_14">
							<span class="p_m_l_20 type_size_18">解析</span>
							<div class="p_f_1 p_m_l_20 p_m_r_20"><el-input v-model="val.analysis" placeholder="请输入解析"></el-input></div>
						</div>
					</div>
					<div v-if="item.Questions.length != 0">
						<div class="answers_box p_m_t_14">
							<div id="" class="answers_header p_flex p_f_b">
								<span>上传图片</span>
								<div class="answers_img">
									<el-upload
										class="upload-demo"
										:action="$request.ajaxUrl + '/Upload/image/type/teacher'"
										:data="{ index }"
										:headers="$request.headers(true)"
										:show-file-list="false"
										multiple
										:on-success="uploadImage"
									>
										<i class="el-icon-picture subject_color type_size_20"></i>
									</el-upload>
								</div>
							</div>
							<div id="">
								<div class="p_flex " style="flex-wrap: wrap;">
									<div style="position: relative;" v-for="img in item.image" :key="img.index">
										<el-image
											style="width: 120px; height: 120px;margin-top: 15px;margin-right: 15px;position: relative;"
											:src="img"
											:preview-src-list="item.image"
										></el-image>
										<div class="xiao_imgs  small_hand" @click.stop="imgDelete(index, img.index)"><img src="../../../../assets/img/xiaoshen.png" /></div>
									</div>
								</div>
							</div>
						</div>
						<div class="p_m_t_30">
							<div id="">
								<span class="type_size_18">学生答题</span>
								<div id="">
									<el-radio-group v-model="item.patternId">
										<el-radio style="margin-top: 15px;" v-for="(radio, i) in item.pattern" :key="i" :label="radio.id">{{ radio.name }}</el-radio>
									</el-radio-group>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 材料 -->
				<div v-if="item.questionTypes == 6">
					<div id="" class="p_m_t_14 " v-for="(val, i) in item.Materials" :key="i">
						<div id="" class="p_flex">
							<div>
								<span class="type_size_22" style="font-weight: bold;">{{ i + 1 }}</span>
							</div>
							<div>
								<div class="p_flex p_f_a">
									<div class="" style="width: 120px;">
										<div class="p_flex  p_f_a p_loginb p_m_l_20">
											<div class="p_m_l_20 loginb"><el-input v-model="val.grade"></el-input></div>
											<span class="type_size_18 p_m_r_20">分</span>
										</div>
									</div>
									<div class="shan_img small_hand p_m_l_30" @click="MaterialsDeletes(index, i)"><img src="../../../../assets/img/dashan.png" /></div>
								</div>
							</div>
						</div>
						<div id="" class="p_m_t_20">
							<div class="p_m_b_20 p_flex p_f_a " v-for="(gap, key) in val.expenses" :key="key">
								<div class="p_login p_f_1  p_flex p_f_a">
									<span class="p_m_l_20 type_size_18">{{ key + 1 }}</span>
									<div class="p_f_1 p_m_l_20 "><el-input v-model="gap.text"></el-input></div>
									<div class="xiao_img  small_hand" v-if="key == val.expenses.length - 1" @click.stop="materialsDelete(index, i, key)">
										<img src="../../../../assets/img/xiaoshen.png" />
									</div>
								</div>
								<div class="shan_img small_hand p_m_l_30" v-if="key == val.expenses.length - 1" @click="materialsAadd(index, i, key + 1)">
									<img src="../../../../assets/img/daadd.png" />
								</div>
							</div>
						</div>
						<div class="p_login p_flex p_f_a p_m_t_14">
							<span class="p_m_l_20 type_size_18">解析</span>
							<div class="p_f_1 p_m_l_20 p_m_r_20"><el-input v-model="val.analysis" placeholder="请输入解析"></el-input></div>
						</div>
					</div>
					<div id="" v-if="item.Materials.length != 0">
						<div class="answers_box p_m_t_14">
							<div id="" class="answers_header p_flex p_f_b">
								<span>上传图片</span>
								<div class="answers_img">
									<el-upload
										class="upload-demo"
										:action="$request.ajaxUrl + '/Upload/image/type/teacher'"
										:data="{ index }"
										:headers="$request.headers(true)"
										:show-file-list="false"
										multiple
										:on-success="uploadImage"
									>
										<i class="el-icon-picture subject_color type_size_20"></i>
									</el-upload>
								</div>
							</div>
							<div id="">
								<div class="p_flex " style="flex-wrap: wrap;">
									<div style="position: relative;" v-for="img in item.image" :key="img.index">
										<el-image
											style="width: 120px; height: 120px;margin-top: 15px;margin-right: 15px;position: relative;"
											:src="img"
											:preview-src-list="item.image"
										></el-image>
										<div class="xiao_imgs  small_hand" @click.stop="imgDelete(index, img.index)"><img src="../../../../assets/img/xiaoshen.png" /></div>
									</div>
								</div>
							</div>
						</div>
						<div class="p_m_t_30">
							<div id="">
								<span class="type_size_18">学生答题</span>
								<div id="">
									<el-radio-group v-model="item.patternId">
										<el-radio style="margin-top: 15px;" v-for="(radio, i) in item.pattern" :key="i" :label="radio.id">{{ radio.name }}</el-radio>
									</el-radio-group>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="p_flex p_f_c p_m_t_30"><el-button type="info" icon="el-icon-circle-plus-outline" @click="goAdd">添加题目</el-button></div>
			<div class="p_flex p_f_c p_m_t_30 Confirm"><el-button type="success" @click="goConfirm">提交</el-button></div>
		</div>
	</div>
</template>

<script>
import Info from '../../../../assets/js/public.js';
export default {
	props: {
		name: [Number, String],
		url: [Number, String],
		srcList: Array,
		file_type: [Number, String]
	},
	data() {
		return {
			gradeTypes: '',
			gradeLists: [],
			subjectTypes: '',
			subjectLists: [],
			questionType: [],
			questionTypes: '',
			grade: '',
			listBook: [],
			engList: []
		};
	},
	created() {
		this.engList = Info.English;
		this.$request
			.ajax(this)
			.post('/Library/questionType')
			.then(res => {
				// console.log(res)
				this.questionType = res.data;
				this.questionTypes = res.data[0].id;
				var data = {};
				// 类型
				data.questionType = res.data;
				data.questionTypes = res.data[0].id;
				data.grade = '';
				data.image = [];
				data.patternId = 3;
				data.pattern = [
					{
						id: 1,
						name: '文字答题'
					},
					{
						id: 2,
						name: '上传图片答题'
					},
					{
						id: 3,
						name: '全部'
					}
				];
				// 单选数组
				data.MultipleChoice = [];
				// 多选数组
				data.MultiSelect = [];
				// 判断数组
				data.Estimate = [];
				// 填空
				data.GapList = [];
				// 问答
				data.Questions = [];
				// 材料
				data.Materials = [];
				// 单选数组
				// data.MultipleChoice = [
				// 	{
				// 		radio: 'A',
				// 		engList: this.engList.slice(0, 4),
				// 		grade: '',
				// 		analysis: ''
				// 	}
				// ];
				// 多选数组
				// data.MultiSelect = [
				// 	{
				// 		choice: ['A', 'B'],
				// 		engList: this.engList.slice(0, 4),
				// 		analysis: '',
				// 		grade: ''
				// 	}
				// ];
				// 判断
				// data.Estimate = [
				// 	{
				// 		judge: 'A',
				// 		judgeList: [
				// 			{
				// 				id: 'A',
				// 				name: '对'
				// 			},
				// 			{
				// 				id: 'B',
				// 				name: '错'
				// 			}
				// 		],
				// 		analysis: '',
				// 		grade: ''
				// 	}
				// ];
				// 填空
				// data.GapList = [
				// 	{
				// 		analysis: '',
				// 		grade: '',
				// 		gap: [
				// 			{
				// 				text: ''
				// 			}
				// 		]
				// 	}
				// ];
				// 问答
				// data.Questions = [
				// 	{
				// 		analysis: '',
				// 		grade: '',
				// 		textarea: ''
				// 	}
				// ];
				// 材料
				// data.Materials = [
				// 	{
				// 		analysis: '',
				// 		grade: '',
				// 		expenses: [
				// 			{
				// 				name: 1,
				// 				text: ''
				// 			}
				// 		]
				// 	}
				// ];
				this.listBook.push(data);
				console.log(this.listBook);
			});
		this.$request
			.ajax(this)
			.post('/Library/grade')
			.then(res => {
				//年纪
				// console.log(res)
				this.gradeLists = res.data;
			});
		this.$request
			.ajax(this)
			.post('/api_teacher/teacher_subject')
			.then(res => {
				// console.log(res)
				this.subjectLists = res.data;
			});
	},
	methods: {
		gets() {},
		goAdd() {
			var data = {};
			data.questionType = this.questionType;
			data.questionTypes = this.questionType[0].id;
			data.grade = '';
			data.image = [];
			data.patternId = 3;
			data.pattern = [
				{
					id: 1,
					name: '文字答题'
				},
				{
					id: 2,
					name: '上传图片答题'
				},
				{
					id: 3,
					name: '全部'
				}
			];
			// 单选数组
			data.MultipleChoice = [];
			// 多选数组
			data.MultiSelect = [];
			// 判断数组
			data.Estimate = [];
			// 填空
			data.GapList = [];
			// 问答
			data.Questions = [];
			// 材料
			data.Materials = [];
			this.listBook.push(data);
			console.log(this.listBook);
		},
		// 单选删除
		radioDelete(index, e, key) {
			for (var i = 0; i < this.listBook[index].MultipleChoice[e].engList.length; i++) {
				if (i == key) {
					this.listBook[index].MultipleChoice[e].engList.splice(i, 1);
					this.listBook[index].MultipleChoice[e].engList = this.listBook[index].MultipleChoice[e].engList.slice(0, this.listBook[index].MultipleChoice[e].engList.length);
				}
			}
		},
		// 单选添加
		radiAadd(index, e) {
			this.listBook[index].MultipleChoice[e].engList = this.engList.slice(0, this.listBook[index].MultipleChoice[e].engList.length + 1);
		},
		// 单选删题
		radioDeletes(index, e) {
			this.listBook[index].MultipleChoice.splice(e, 1);
		},
		// 添加题型
		newAdd(index) {
			var questionTypes = this.listBook[index].questionTypes;
			if (questionTypes == 1) {
				this.listBook[index].MultipleChoice.push({
					radio: 'A',
					engList: this.engList.slice(0, 4),
					grade: '',
					analysis: ''
				});
			} else if (questionTypes == 2) {
				this.listBook[index].MultiSelect.push({
					choice: ['A', 'B'],
					engList: this.engList.slice(0, 4),
					analysis: '',
					grade: ''
				});
			} else if (questionTypes == 3) {
				this.listBook[index].Estimate.push({
					judge: 'A',
					judgeList: [
						{
							id: 'A',
							name: '对'
						},
						{
							id: 'B',
							name: '错'
						}
					],
					analysis: '',
					grade: ''
				});
			} else if (questionTypes == 4) {
				this.listBook[index].GapList.push({
					analysis: '',
					grade: '',
					gap: [
						{
							text: ''
						}
					]
				});
			} else if (questionTypes == 5) {
				this.listBook[index].Questions.push({
					analysis: '',
					grade: '',
					textarea: ''
				});
			} else {
				this.listBook[index].Materials.push({
					analysis: '',
					grade: '',
					expenses: [
						{
							name: 1,
							text: ''
						}
					]
				});
				console.log(this.listBook[index]);
			}
		},
		// 删除题型
		newDelete(index) {
			this.listBook.splice(index, 1);
		},
		// 多选删除
		checkboxDelete(index, e, key) {
			for (var i = 0; i < this.listBook[index].MultiSelect[e].engList.length; i++) {
				if (i == key) {
					this.listBook[index].MultiSelect[e].engList.splice(i, 1);
					this.listBook[index].MultiSelect[e].engList = this.engList.slice(0, this.listBook[index].MultiSelect[e].engList.length);
					this.listBook[index].MultiSelect[e].choice.splice(i, 1);
				}
			}
		},
		// 多选删题
		checkboxDeletes(index, e) {
			this.listBook[index].MultiSelect.splice(e, 1);
		},
		// 多选添加
		checkboxAadd(index, e) {
			this.listBook[index].MultiSelect[e].engList = this.engList.slice(0, this.listBook[index].MultiSelect[e].engList.length + 1);
		},
		// 判断删题
		estimateDelete(index, e) {
			this.listBook[index].Estimate.splice(e, 1);
		},
		// 添加填空
		gapAadd(index, e) {
			this.listBook[index].GapList[e].gap.push({
				text: ''
			});
		},
		// 删除填空
		gapDelete(index, e, key) {
			this.listBook[index].GapList[e].gap.splice(key, 1);
		},
		// 删除填空题
		GapListDelete(index, e) {
			this.listBook[index].GapList.splice(e, 1);
		},
		// 删除问答
		QuestionsDelete(index, e) {
			this.listBook[index].Questions.splice(e, 1);
		},
		// 添加材料小题
		materialsAadd(index, i, k) {
			this.listBook[index].Materials[i].expenses.push({
				name: k + 1,
				text: ''
			});
		},
		// 删除材料小题
		materialsDelete(index, i, k) {
			this.listBook[index].Materials[i].expenses.splice(k, 1);
		},
		// 删除材料
		MaterialsDeletes(index, i) {
			this.listBook[index].Materials.splice(i, 1);
		},
		// 上传图片
		uploadImage(e) {
			console.log(e);
			this.listBook[e.data.index].image.push(e.data.file);
		},
		imgDelete(i, key) {
			this.listBook[i].image.splice(key, 1);
		},
		// 提交
		goConfirm() {
			if (this.name == '') {
				this.$message.error('请填写试卷名称');
				return;
			}
			if (this.subjectTypes == '') {
				this.$message.error('请选择学科');
				return;
			}
			if (this.gradeTypes == '') {
				this.$message.error('请选择年级');
				return;
			}
			var data = {};
			data.name = this.name;
			data.subject = this.subjectTypes;
			data.grade = this.gradeTypes;
			if (this.file_type == 3) {
				data.file_url = this.srcList;
			} else {
				data.file_url = this.url;
			}
			data.file_type = this.file_type;
			data.question = [];
			for (var i = 0; i < this.listBook.length; i++) {
				// 单选
				if (this.listBook[i].questionTypes == 1) {
					var MultipleChoice = [];
					for (var j = 0; j < this.listBook[i].MultipleChoice.length; j++) {
						MultipleChoice.push({
							question_type: this.listBook[i].questionTypes,
							title: i + 1,
							score: this.listBook[i].MultipleChoice[j].grade,
							answer: this.listBook[i].MultipleChoice[j].radio,
							analysis: this.listBook[i].MultipleChoice[j].analysis,
							affiliation: []
						});
						for (var k = 0; k < this.listBook[i].MultipleChoice[j].engList.length; k++) {
							MultipleChoice[j].affiliation.push({
								name: this.listBook[i].MultipleChoice[j].engList[k],
								text: ''
							});
						}
					}
					for (var m = 0; m < MultipleChoice.length; m++) {
						data.question.push(MultipleChoice[m]);
					}
				} else if (this.listBook[i].questionTypes == 2) {
					// 多选
					var MultiSelect = [];
					for (var j = 0; j < this.listBook[i].MultiSelect.length; j++) {
						MultiSelect.push({
							question_type: this.listBook[i].questionTypes,
							title: i + 1,
							score: this.listBook[i].MultiSelect[j].grade,
							answer: this.listBook[i].MultiSelect[j].choice.join(''),
							analysis: this.listBook[i].MultiSelect[j].analysis,
							affiliation: []
						});
						for (var k = 0; k < this.listBook[i].MultiSelect[j].engList.length; k++) {
							MultiSelect[j].affiliation.push({
								name: this.listBook[i].MultiSelect[j].engList[k],
								text: ''
							});
						}
					}
					for (var m = 0; m < MultiSelect.length; m++) {
						data.question.push(MultiSelect[m]);
					}
				} else if (this.listBook[i].questionTypes == 3) {
					// 判断
					for (var j = 0; j < this.listBook[i].Estimate.length; j++) {
						data.question.push({
							question_type: this.listBook[i].questionTypes,
							title: i + 1,
							score: this.listBook[i].Estimate[j].grade,
							answer: this.listBook[i].Estimate[j].judge,
							analysis: this.listBook[i].Estimate[j].analysis
						});
					}
				} else if (this.listBook[i].questionTypes == 4) {
					// 填空
					var GapList = [];
					for (var j = 0; j < this.listBook[i].GapList.length; j++) {
						GapList.push({
							question_type: this.listBook[i].questionTypes,
							title: i + 1,
							score: this.listBook[i].GapList[j].grade,
							analysis: this.listBook[i].GapList[j].analysis,
							answer_mode: this.listBook[i].patternId,
							answer_image: this.listBook[i].image,
							affiliation: []
						});
						for (var k = 0; k < this.listBook[i].GapList[j].gap.length; k++) {
							GapList[j].affiliation.push({
								name: k + 1,
								text: this.listBook[i].GapList[j].gap[k].text
							});
						}
					}
					for (var m = 0; m < GapList.length; m++) {
						data.question.push(GapList[m]);
					}
				} else if (this.listBook[i].questionTypes == 5) {
					// 问答
					for (var j = 0; j < this.listBook[i].Questions.length; j++) {
						data.question.push({
							question_type: this.listBook[i].questionTypes,
							title: i + 1,
							score: this.listBook[i].Questions[j].grade,
							analysis: this.listBook[i].Questions[j].analysis,
							answer_mode: this.listBook[i].patternId,
							answer_image: this.listBook[i].image,
							answer: this.listBook[i].Questions[j].textarea
						});
					}
				} else if (this.listBook[i].questionTypes == 6) {
					// 材料
					var Materials = [];
					for (var j = 0; j < this.listBook[i].Materials.length; j++) {
						Materials.push({
							question_type: this.listBook[i].questionTypes,
							title: i + 1,
							score: this.listBook[i].Materials[j].grade,
							analysis: this.listBook[i].Materials[j].analysis,
							answer_mode: this.listBook[i].patternId,
							answer_image: this.listBook[i].image,
							affiliation: []
						});
						for (var k = 0; k < this.listBook[i].Materials[j].expenses.length; k++) {
							Materials[j].affiliation.push({
								name: k + 1,
								text: this.listBook[i].Materials[j].expenses[k].text
							});
						}
					}
					for (var m = 0; m < Materials.length; m++) {
						data.question.push(Materials[m]);
					}
				}
			}
			if (data.question.length != 0) {
				for (var i = 0; i < data.question.length; i++) {
					data.question[i].title = i + 1;
				}
			}
			this.goConfirmInfo(data);
		},
		goConfirmInfo(data) {
			this.$request
				.ajax(this)
				.post('/api_teacher/question_card_create', data)
				.then(res => {
					this.$message({
						message: '录入成功',
						type: 'success'
					});
					this.$router.go(-1);
				});
		}
	}
};
</script>
<style lang="scss" scoped>
.button {
	width: 100px;
	margin: 10px 0 10px 20px;
}
.header_box {
	padding: 30px;
	background-color: #ffffff;
}
>>> .el-input__inner {
	border: none;
	background-color: #f5f5f5;
	font-size: 18px;
	color: #333;
	padding: 0;
}

>>> input::-webkit-input-placeholder {
	font-size: 18px;
}
.p_login {
	position: relative;
	width: 100%;
	height: 50px;
}
>>> .el-select {
}
.radio {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	background: #f5f5f5;
	color: #999999;
	padding: 10px;
	font-size: 16px;
}
.radio_color {
	background-color: #00af63;
	color: #ffffff;
}
.box_center {
	background-color: #ffffff;
	padding: 0 30px 30px;
}
.p_loginb {
	height: 40px;
	background: #f5f5f5;
	opacity: 1;
	border-radius: 8px;
}
.loginb > input {
	display: block;
	width: 60px;
}
.shan_img {
	width: 30px;
	height: 30px;
}
.shan_img > img {
	width: 100%;
	height: 100%;
}
>>> .el-button {
	font-size: 20px;
	color: #00af63;
}
>>> .el-button--info {
	background-color: #f5f5f5;
	border-color: #f5f5f5;
}
>>> .el-radio__input.is-checked .el-radio__inner {
	border-color: #00af63;
	background: #00af63;
}
>>> .el-radio__input.is-checked + .el-radio__label {
	color: #00af63;
}
>>> .el-radio__inner {
	width: 20px;
	height: 20px;
}
>>> .el-radio__label {
	font-size: 18px;
}
>>> .el-radio__inner:hover {
	border-color: #999999;
}
>>> .el-radio__inner::after {
	width: 8px;
	height: 8px;
}
.Confirm >>> .el-button {
	color: #ffffff;
}
.xiao_img {
	position: absolute;
	right: 0px;
	top: 0px;
	width: 12px;
	height: 12px;
	z-index: 99;
}
.xiao_img img {
	width: 100%;
	height: 100%;
}
.xiao_imgs {
	position: absolute;
	right: 15px;
	top: 10px;
	width: 12px;
	height: 12px;
	z-index: 99;
}
.xiao_imgs img {
	width: 100%;
	height: 100%;
}
.boder_box {
	padding: 30px 0;
	border-bottom: 1px solid #e6e6e6;
}
>>> .el-radio-button__inner {
	border: none !important;
	background-color: #f5f5f5;
	border-color: #f5f5f5;
	margin-left: 15px;
	margin-bottom: 15px;
}
>>> .el-radio-button__orig-radio:checked + .el-radio-button__inner {
	background-color: #00af63;
	border-color: #00af63;
}
>>> .el-radio-button:first-child >>> .el-radio-button__inner {
	border-left: none;
}
>>> .el-checkbox-button__inner {
	border: none !important;
	background-color: #f5f5f5;
	border-color: #f5f5f5;
	margin-left: 15px;
	margin-bottom: 15px;
}
>>> .el-checkbox-button.is-checked .el-checkbox-button__inner {
	background-color: #00af63;
	border-color: #00af63;
}
.answers_header {
	padding: 10px;
	background-color: #f5f5f5;
}
.answer_conetr {
	background-color: #fafafa;
	padding: 10px;
}
>>> .el-textarea__inner {
	border: none;
	background-color: #fafafa;
}
.answers_img {
	width: 25px;
	height: 20px;
}
.answers_img >>> .el-upload {
	height: 100%;
}
>>> .upload-demo {
	height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/answer_sheet/components/bian_ji.vue